/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'idalgo': {
    width: 3885,
    height: 3871,
    viewBox: '0 0 3885 3871',
    data: '<defs><path pid="0" d="M1942.291 3870.968C869.593 3870.968 0 3004.422 0 1935.484 0 866.546 869.593 0 1942.291 0c1072.698 0 1942.291 866.546 1942.291 1935.484 0 1068.938-869.593 1935.484-1942.291 1935.484zm-882.086-1844.616c-117.876 544.766 232.675 1081.186 778.132 1199.455 205.101 39.85 457.113-360.015 571.441-908.678 120.764-558.251 52.935-1025.447-145.9-1066.182-551.723-117.385-1090.333 231.704-1203.673 775.405zm498.491-848.1c218.403-107.405 474.796-142.631 729.499-84.81 33.573 3.292 61.427 13.826 85.108 24.232 254.676-178.876 380.001-381.152 182.375-436.166-412.073-117.752-837.719 63.344-1045.615 411.934-29.331 46.549 4.601 99.592 48.633 84.81z" id="svgicon-idalgo-a"/></defs><use _fill="#FFF" xlink:href="#svgicon-idalgo-a" fill-rule="evenodd"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/idalgo.js